import React from 'react';
import { connect } from 'react-redux';
import * as Routes from 'routes';
import PropTypes from 'prop-types';
import { routeNames } from 'constants/routeNames';
import {
  BrowserRouter as Router,
} from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import theme from 'themes/theme';

// actions
import * as Actions from 'actions';

// config
import {
  REACT_APP_CLIENT_NAME,
  REACT_APP_CLIENT_WEBSITE,
  REACT_APP_CLIENT_EMAIL,
  REACT_APP_CLIENT_COLOR,
  REACT_APP_API,
  REACT_APP_FAVICON,
} from 'config';

// helpers
import { setFavicon } from 'helpers';

// component
import WrapperRootPage from '../component/WrapperRootPage';

const mapStateToProps = state => ({
  errors: state.errors,
  app: state.app,
  user: state.user,
  userApps: state.userApps,
  workspaces: state.workspaces,
});

const mapDispatchToProps = dispatch => ({
  checkAccess: (...args) => dispatch(Actions.checkAccess(...args)),
  getWorkspaces: (...args) => dispatch(Actions.getWorkspaces(...args)),
  setCurrentWorkspace: (...args) => dispatch(Actions.setCurrentWorkspace(...args)),
  getCurrentUser: (...args) => dispatch(Actions.getCurrentUser(...args)),
  getUserApps: (...args) => dispatch(Actions.getUserApps(...args)),
  getAreas: (...args) => dispatch(Actions.getAreas(...args)),
  storeResetPasswordToken: (...args) => dispatch(Actions.storeResetPasswordToken(...args)),
  signout: (...args) => dispatch(Actions.signout(...args)),
  requestResetPassword: (...args) => dispatch(Actions.requestResetPassword(...args)),
  resetPassword: (...args) => dispatch(Actions.resetPassword(...args)),
  signup: (...args) => dispatch(Actions.signup(...args)),
  validateEmail: (...args) => dispatch(Actions.validateEmail(...args)),
  setDarkMode: (...args) => dispatch(Actions.setDarkMode(...args)),
  stopImpersonate: (...args) => dispatch(Actions.stopImpersonate(...args)),
});

class RootPage extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    checkAccess: PropTypes.func,
    getCurrentUser: PropTypes.func,
    getUserApps: PropTypes.func,
    signout: PropTypes.func,
    signup: PropTypes.func,
    validateEmail: PropTypes.func,
    requestResetPassword: PropTypes.func,
    resetPassword: PropTypes.func,

    user: PropTypes.object,
    userApps: PropTypes.array,
    errors: PropTypes.object,
    app: PropTypes.object,

    storeResetPasswordToken: PropTypes.func,
    setDarkMode: PropTypes.func,
    getAreas: PropTypes.func,

    getWorkspaces: PropTypes.func,
    setCurrentWorkspace: PropTypes.func,

    stopImpersonate: PropTypes.func,
  };

  static childContextTypes = {
    checkAccess: PropTypes.func,
    userApps: PropTypes.array,
  };

  getChildContext() {
    const { checkAccess, userApps } = this.props;
    return {
      checkAccess,
      userApps,
    };
  }

  componentWillMount() {
    console.log(`%cDeveloped by ${REACT_APP_CLIENT_NAME}`, `color: ${REACT_APP_CLIENT_COLOR}; font-size: 28px`);
    console.log('%cin Los Angeles, California', 'color: #607d8b; font-size: 18px');
    console.log(`%c${REACT_APP_CLIENT_EMAIL}`, 'color: #607d8b; font-size: 12px');
    console.log(`%c${REACT_APP_CLIENT_WEBSITE}`, 'color: #607d8b; font-size: 12px');
    console.log(`%cRunning on ${REACT_APP_API} API`, 'color: #607d8b; font-size: 12px');
    setFavicon(REACT_APP_FAVICON);
  }

  getRoutes() {
    const { user } = this.props;
    const routes = [];

    for (const k in routeNames) {
      if (routeNames.hasOwnProperty(k)) {
        const route = Routes[routeNames[k]](user ? user.services : {});
        if (route.onEnter()) {
          routes.unshift(route);
        }
      }
    }

    return routes;
  }

  getAllRoutes() {
    const { user } = this.props;
    const routes = [];

    for (const k in routeNames) {
      if (routeNames.hasOwnProperty(k)) {
        const route = Routes[routeNames[k]](user ? user.services : {});
        routes.unshift(route);
      }
    }

    return routes;
  }

  init() {
    const { getUserApps, getAreas } = this.props;
    return Promise.all([
      getUserApps(),
      getAreas()
    ]);
  }

  render() {
    const {
      app,
      user,
      getCurrentUser,
      checkAccess,
      signout,
      errors,
      signup,
      validateEmail,
      requestResetPassword,
      storeResetPasswordToken,
      resetPassword,
      setDarkMode,
      userApps,
      stopImpersonate,
      history,
    } = this.props;

    const muiTheme = createMuiTheme({
      palette: { ...theme, type: this.props.app.darkMode ? 'dark' : 'light' },
      typography: {
        useNextVariants: true,
      },
    });

    return (
      <MuiThemeProvider theme={muiTheme}>
        <Router>
          <WrapperRootPage
            stopImpersonate={stopImpersonate}
            setDarkMode={setDarkMode}
            app={app}
            checkAccess={checkAccess}
            getCurrentUser={getCurrentUser}
            storeResetPasswordToken={storeResetPasswordToken}
            signout={signout}
            requestResetPassword={requestResetPassword}
            resetPassword={resetPassword}
            validateEmail={validateEmail}
            signup={signup}
            user={user}
            userApps={userApps}
            errors={errors}
            routes={this.getRoutes()}
            allRoutes={this.getAllRoutes()}
            init={this.init.bind(this)}
            history={history}
          />
        </Router>
      </MuiThemeProvider>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(RootPage);
